import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type LoadingStateVariant = 'spinner' | 'skeleton-cards' | 'skeleton-table';

/** Columnas de cada fila del skeleton de tabla (lista estática sin identidad de dominio). */
const SKELETON_COLUMNS: readonly number[] = [0, 1, 2, 3];

/** Estado de carga único de la app: spinner o skeletons de tarjetas/tabla. */
@Component({
    selector: 'app-loading-state',
    standalone: true,
    imports: [],
    templateUrl: './loading-state.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingStateComponent {
    readonly variant = input<LoadingStateVariant>('spinner');
    readonly message = input<string>('Cargando…');
    /** Cantidad de tarjetas o filas de los skeletons. */
    readonly count = input<number>(3);

    protected readonly rootClass = computed(() => `rbi-loading-state rbi-loading-state--${this.variant()}`);
    protected readonly isSpinner = computed(() => this.variant() === 'spinner');
    protected readonly isCards = computed(() => this.variant() === 'skeleton-cards');
    protected readonly items = computed(() =>
        Array.from({ length: Math.max(0, Math.floor(this.count())) }, (_, index) => index),
    );
    protected readonly columns = SKELETON_COLUMNS;
}
